import { FlashMessageService } from './../../../../../shared/services/flash-message.service';
import { CanadianProvinces } from './../../../../../../assets/data/canadian-provinces';
import { USStates } from 'src/assets/data/us-states';
import { FormGroup, FormArray, AbstractControl } from '@angular/forms';
import { MassSuppliersService } from './../../../../../services/mass-suppliers/mass-suppliers.service';
import { CountryAbbreviationEnum } from './../../../../../shared/enum/country-abbreviation.enum';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { MexicanStates } from 'src/assets/data/mexican-states';
import { ValidationMessages } from 'src/app/shared/enum/validation-messages.enum';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';

@Component({
  selector: 'invalid-supplier-detail',
  templateUrl: './invalid-supplier-detail.component.html',
  styleUrls: ['./invalid-supplier-detail.component.scss']
})
export class InvalidSupplierDetailComponent implements OnInit {

  constructor(private _massSupplierService: MassSuppliersService,
    private currentUserService: CurrentUserService,
    private _gaSvc: GoogleAnalyticsService,
    private _flashMessageService: FlashMessageService, private ref: ChangeDetectorRef) { }

  @Input() supplier: any = {};
  @Input() potentialMatches: any[] =  [];

  @Output() updated = new EventEmitter<any>();

  public loading: boolean;
  public panelOpenState: boolean;
  public isValidSupplier: boolean;
  public supplierForm: FormGroup;
  public statesDD: any[] = [];
  public countryDD: any[] = Array.from(
    Object.keys(CountryAbbreviationEnum).map(k => CountryAbbreviationEnum[k as any])
  );
  public emailValidationMessage = ValidationMessages.EXISTING_EMAIL;
  public emailValid;

  async ngOnInit() {
    this.supplierForm = this._massSupplierService.getSupplierForm(this.supplier);
    await setTimeout(this.setFormStatus.bind(this), 800);
    this._initStateDD();
  }

  setFormStatus() {
    this.isValidSupplier = this.supplierForm.valid;
    this.ref.detectChanges();
  }

  /**
   * Check if given field is valid or not
   * @param field
   * @param parentField
   * @param index
   */
  public isValidField(field: string, parentField: string = null, index: number = -1, duplicateCheck: boolean = false) {
    if (!field) return false;
    let control: AbstractControl;

    if (!parentField && index < 0) {
      control = this.supplierForm.get(field);
    } else {
      // check for child form group
      if (index < 0) {
        control = this.supplierForm.get(parentField).get(field);
      } else {
        //check for child form array
        control = (this.supplierForm.get(parentField) as FormArray).at(index).get(field);
      }
    }

    return duplicateCheck ? control.hasError('duplicateEmail') : control.hasError('required') || control.hasError('pattern') || control.hasError('postalCode') || control.hasError('duplicateEmail');
  }

  /**
   * Make supplier valid even if it has potential dublicate on confirm by user
   */
  public confirmSupplier() {
    this._gaSvc.register('Mass Upload Supplier', `Confirmed supplier is valid one.`);
    this._massSupplierService.confirmSupplier(this.supplierForm.value).subscribe(result => {
      this._flashMessageService.updateMessage('Successfully updated supplier information.', 3000, 'success');
      this.updated.emit({});
    }, err => {
      this._flashMessageService.updateMessage('Error occured while updating supplier.');
    });
  }

  /**
   * Update supplier info to temp collection for mass suppliers
   */
  public updateChanges() {
    this._gaSvc.register('Mass Upload Supplier', `Updated Invalid supplier.`);
    if (this.supplierForm.valid) {
      this.loading = true;

      this._massSupplierService.updateSupplier(this.supplierForm.value).subscribe(result => {
        if (result['isValid']) {
          // update supplier as valid supplier in temp collection
          this.confirmSupplier();
        } else {
          // Ask user to confirm if supplier has potential matches
          this.potentialMatches = result['data']['supplier_potential_matches'];
          this.isValidSupplier = true;
        }

        this.loading = false;
      }, () => {
        this._flashMessageService.updateMessage('Error occured while updating supplier.');
      });
    }
  }
/**
 * Reset locationInfo and change states dropdown
 * @param $event
 */
  public onCountryChanged($event) {
    this._resetLocation();
    this._initStateDD($event.target.value);
  }

  /**
   * Get Names for potential matched supplier
   */
  public getPotentialMatches() {
    return this.potentialMatches.map(mSup => mSup.supplier_name).join(', ');
  }


  /**
   * Reset Location information
   */
  private _resetLocation(): void {
    this.supplierForm.get('location').patchValue({
      address: '',
      city: '',
      state: '',
      zipCode: ''
    });
  }

  /**
   * Initialize dropdown for states based on country
   * @param country
   */
  private _initStateDD(country: string = CountryAbbreviationEnum.USA): void {
    //change state dropdown based on country
    switch (country) {
      case CountryAbbreviationEnum.USA:
        this.statesDD = USStates;
        break;
      case CountryAbbreviationEnum.CANADA:
        this.statesDD = CanadianProvinces;
        break;
      case CountryAbbreviationEnum.MEXICO:
        this.statesDD = MexicanStates;
        break;
    };
  }
}
